import React from 'react';
import { connect } from 'react-redux';
import { Box, Button, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { API_ROOT } from '../../../../baseUrls';
import Loader from '../../../organisms/loader/Loader';

class Site extends React.Component {
  state = {
    site: null,
    loading: true,
  };

  componentDidMount() {
    this.startSiteLoad(new Date().toJSON());
  }

  startSiteLoad(dateString) {
    this.setState({ loading: true });
    fetch(`${API_ROOT}/mindfiles/${this.props.user.mid}/admin/site?date=${encodeURIComponent(dateString)}`, {
      method: 'GET',
      credentials: 'include',
    })
    .then(resp => resp.json())
    .then(site => this.setState({ site, loading: false }))
    .catch(error => console.error(error));
  }

  render() {
    if (!this.state.site) {
      return <Loader />;
    }
    return (
      <Box>
        <h2>Total Signups</h2>
        <p>{this.state.site.signups}</p>
        <h2>Activated User Accounts</h2>
        <p>{this.state.site.total_users}</p>
        <h2>Users with Profile Pictures</h2>
        <p>{this.state.site.avatars}</p>
        <h2>Users with Uploads</h2>
        <p>{this.state.site.uploaders}</p>
        <h2>Total Uploads</h2>
        <p>{this.state.site.total_count}</p>
        <FileSizeTable sizes={this.state.site.total} />
        <h2>{new Date(this.state.site.date).toLocaleDateString('default', { month: 'long', year: 'numeric' })}</h2>
        <h3>New Users</h3>
        <p>{this.state.site.monthly_users}</p>
        <h3>New Uploads</h3>
        <p>{this.state.site.month_count}</p>
        <FileSizeTable sizes={this.state.site.month} />
        <Button disabled={this.state.loading} onClick={() => this.startSiteLoad(this.state.site.back)}>Back</Button>
        <Button disabled={this.state.loading || !this.state.site.forward} onClick={() => this.startSiteLoad(this.state.site.forward)}>Forward</Button>
      </Box>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth,
  };
}

export default connect(mapStateToProps)(Site);

function FileSizeTable(props) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Documents</TableCell>
          <TableCell>Images</TableCell>
          <TableCell>Posts</TableCell>
          <TableCell>Audio</TableCell>
          <TableCell>Videos</TableCell>
          <TableCell>Other</TableCell>
        </TableRow>
      </TableHead>
      <TableBody style={{backgroundColor: "#fff"}}>
        {props.sizes.map((row, i) =>
          <TableRow key={i}>
            <TableCell>{row.document || "0"}</TableCell>
            <TableCell>{row.image || "0"}</TableCell>
            <TableCell>{row.post || "0"}</TableCell>
            <TableCell>{row.audio || "0"}</TableCell>
            <TableCell>{row.video || "0"}</TableCell>
            <TableCell>{row.file || "0"}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}